import {
  DeleteTreatyProgramAssociateDeductions,
  DeleteTreatyProgramAssociateDeductionsVariables,
} from "_graphql/mutation/__generated__/DeleteTreatyProgramAssociateDeductions";
import {
  removeAssociateDeduction,
  removeTreatyProgram,
} from "_graphql/visal/mutations/treaty-programs";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RemoveDeductionContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    DeleteTreatyProgramAssociateDeductions,
    DeleteTreatyProgramAssociateDeductionsVariables
  >(removeAssociateDeduction, {
    refetchQueries: ["GetTreatyProgramDeductions"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        id: searchParams?.id || "",
      },
    })
      .then(({ data }) => {
        if (data?.deleteTreatyProgramAssociateDeductions) {
          toast.success("Treaty Deduction Removed Successfully");
          refetch?.();
          setOpen?.(false);
        } else {
          toast.error("Failed to remove Treaty Deduction");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "Failed to remove Treaty Deduction");
      });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Remove Treaty Deduction"
      cancelText="No, Don't Remove Treaty Deduction"
      description="This action would completely remove program deduction from system"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading
              ? "Removing Treaty Deduction..."
              : "Remove Treaty Deduction"}
          </button>
        </>
      )}
    />
  );
}
